module.exports = __webpack_public_path__ + "15b546717e6b79acc796ca3439c8bd40.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/gallery/acne/acne-ingrown-hair-1a.jpg
 ** module id = 429
 ** module chunks = 0
 **/